import { computed } from "vue";
import { useProgressStore } from "@/stores/progressStore";

function dateKey(ts) {
  const d = new Date(ts);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function prevDayKey(key) {
  const [y, m, d] = key.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  const prev = new Date(dt.getTime() - 86400000);
  return dateKey(prev.getTime());
}

export function useStreakEngine(childId) {
  const progressStore = useProgressStore();

  const activity = computed(() => progressStore.activityLog?.[childId] || []);

  const activeToday = computed(() => {
    const todayKey = dateKey(Date.now());
    return activity.value.some(e => dateKey(e.timestamp) === todayKey);
  });

  const streak = computed(() => {
    // unique days with any activity
    const days = new Set(activity.value.map(e => dateKey(e.timestamp)));
    if (!days.size) return 0;

    const todayKey = dateKey(Date.now());
    const yesterdayKey = prevDayKey(todayKey);

    // Start counting from today if active today, otherwise from yesterday
    // This way, a streak isn't broken just because you haven't done anything yet today
    let cur;
    if (days.has(todayKey)) {
      cur = todayKey;
    } else if (days.has(yesterdayKey)) {
      cur = yesterdayKey;
    } else {
      return 0;
    }

    let s = 0;
    while (days.has(cur)) {
      s += 1;
      cur = prevDayKey(cur);
    }
    return s;
  });

  const streakLabel = computed(() => {
    const n = streak.value;
    if (n <= 0) return "Start your streak today";
    if (n === 1) return "1-day streak";
    return `${n}-day streak`;
  });

  return { streak, streakLabel, activeToday };
}
